var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 81,
    viewBox: "0 0 86 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.4151 21.8148C61.8484 15.0786 57.8613 9.1529 52.2117 5.16399C46.562 1.17509 39.6437 -0.598942 32.7717 0.17912C25.8996 0.957183 19.553 4.23309 14.9382 9.38416C10.3234 14.5352 7.76212 21.2024 7.74117 28.1183C7.73603 32.6254 8.82482 37.0665 10.9141 41.0602C7.11057 43.0984 4.09727 46.3492 2.35294 50.2961C0.60862 54.2431 0.233323 58.6597 1.28668 62.8444C2.34004 67.0291 4.76163 70.7417 8.16671 73.3924C11.5718 76.0432 15.765 77.48 20.0802 77.4745H42.9957V70.4237H20.0802C17.0781 70.4326 14.1761 69.3439 11.9207 67.3625C9.66519 65.3811 8.21176 62.6435 7.83395 59.6652C7.45613 56.6869 8.17998 53.6731 9.86926 51.1913C11.5585 48.7094 14.0967 46.9306 17.0061 46.1897L22.0721 44.8818L18.9592 40.6759C16.25 37.0501 14.788 32.6444 14.7921 28.1183C14.8323 22.7807 16.889 17.6556 20.5496 13.7709C24.2103 9.88622 29.2043 7.52909 34.5301 7.17226C39.8559 6.81542 45.1197 8.48525 49.2659 11.8469C53.412 15.2085 56.134 20.0134 56.8859 25.2979L57.2385 27.9702L59.9073 28.3227C64.6172 28.94 68.9814 31.1273 72.2949 34.5311C75.6083 37.9349 77.6773 42.3564 78.1676 47.0813C78.658 51.8061 77.541 56.5583 74.9971 60.5699C72.4533 64.5816 68.6312 67.6184 64.1484 69.1897V76.5474C70.2627 74.9749 75.6715 71.3938 79.5065 66.3787C83.3415 61.3637 85.3803 55.2056 85.2957 48.8928C85.2111 42.5801 83.008 36.4788 79.0401 31.5683C75.0721 26.6578 69.5694 23.2228 63.4151 21.8148Z",
    fill: "url(#paint0_linear_485_2191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.1811 58.814L70.1661 53.829L58.5568 42.2197C57.2346 40.8978 55.4415 40.1553 53.5718 40.1553C51.7022 40.1553 49.9091 40.8978 48.5868 42.2197L36.9775 53.829L41.9625 58.814L50.0464 50.7301V80.9996H57.0973V50.7301L65.1811 58.814Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_485_2191",
    x1: 0.701171,
    y1: 22.6755,
    x2: 85.2689,
    y2: 25.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9360FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/uploadCloud.f5968a116e5f7eed7b7396a0ce71b88d.svg";
export { ForwardRef as ReactComponent };